import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Moment } from 'moment';
import { error } from 'protractor';
import { FiaService } from 'src/app/services/fia.service';
import { MediaService } from 'src/app/services/media.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { LookupFiaStatus } from 'src/app/shared/models/general/lookup-fia-status';
import { LookupMediaTypes } from 'src/app/shared/models/general/lookup-media-types';
import { Media } from 'src/app/shared/models/general/media';
import { MediaInfo } from 'src/app/shared/models/general/media-info';
import { Fia } from 'src/app/shared/models/users/fia';
import { FiaApplication } from 'src/app/shared/models/users/fia-application';
import { UserFullDetails } from 'src/app/shared/models/users/user-full-details';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { Users } from 'src/app/shared/models/users/users';
import { getEmailRegExpression } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-broker-account',
  templateUrl: './broker-account.component.html',
  styleUrls: ['./broker-account.component.scss'],
})
export class BrokerAccountComponent implements OnInit {
  //Modals
  @ViewChild('userInfoModal', { static: true }) userInfoModal: any;
  @ViewChild('userFiaPinsModal', { static: true }) userFiaPinsModal: any;
  @ViewChild('userDocumentsModal', { static: true }) userDocumentsModal: any;
  @ViewChild('userFiaApplicationModal', { static: true }) userFiaApplicationModal: any;
  //File selector
  @ViewChild('file') file;

  busy: boolean = true;
  modalBusy: boolean = false;
  showError: boolean = false;
  errorMsg: string = 'Oops! Looks like something went wrong, please contact support if this issue persists';

  //General
  users: UserFullDetails[] = [];
  fiaStatus: LookupFiaStatus[] = [];
  mediaTypes: LookupMediaTypes[] = [];

  //Selected User
  selectedUser: Users = new Users();
  selectedUserProfile: UserProfile = new UserProfile();
  selectedUserFiaApplcations: FiaApplication[] = [];
  selectedUserDocuments: Media[] = [];
  selectedUserNewDocuments: MediaInfo[] = [];
  selectedUserDocumentsToDelete: number[] = [];

  regexForEmail = getEmailRegExpression();

  //FIA Application
  newFia: Fia = new Fia();
  currentYear = moment().year();
  startDate = moment().add(1, 'days');

  constructor(
    private router: Router,
    public settingsService: SettingsService,
    public usersService: UserService,
    public fiaService: FiaService,
    public mediaService: MediaService
  ) {
    this.busy = true;
    this.settingsService.ValidateGlobalVars().then(() => {
      this.settingsService.GetLookupFiaStatus().then(() => {
        this.fiaStatus = this.settingsService.fiaStatus;
        this.settingsService.GetLookupMediaTypes().then(() => {
          this.mediaTypes = this.settingsService.mediaTypes;
          this.GetBrokerUsers();
        });
      });
    });
  }

  ngOnInit(): void {
    if (!this.settingsService.userIsBroker) {
      //Redirect to login
      this.router.navigate(['/login']);
    }

    this.settingsService.showTextInHeader = true;
    this.settingsService.headerText = 'Manage Users';
  }

  //===============General Methods===============
  SelectUser(user: UserFullDetails) {
    this.selectedUserDocuments = [];
    this.selectedUserDocumentsToDelete = [];
    this.selectedUserNewDocuments = [];
    this.selectedUser = user.user;
    this.selectedUserProfile = user.profile;
    this.selectedUserFiaApplcations = user.fiaApplications;
  }

  //Moment date Functions for fia appliations
  myDateFilter = (m: Moment | null): boolean => {
    const today = m || moment();
    return today >= moment().utcOffset('+02:00').subtract(0, 'days');
  };
  //===============General Methods===============

  //===============CRUD Methods===============
  GetBrokerUsers() {
    this.busy = true;
    this.usersService.GetFullDetailsByEntity(this.settingsService.brokerEntity.id, this.settingsService.brokerUsers[0].brokerId).subscribe(
      (response) => {
        this.users = response;
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  GetUserMedia() {
    this.busy = true;
    this.mediaService.GetFiaSupportingDocuments(this.selectedUserProfile.userId, 0).subscribe(
      (response) => {
        this.selectedUserDocuments = response;
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  DownloadFile(id: number) {
    this.busy = true;
    this.mediaService.DownloadMedia(id).subscribe(
      (response) => {
        //this.selectedUserDocuments = response;
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  //Update user profile
  saveClicked() {
    this.busy = true;
    var userFullDetails = new UserFullDetails();
    userFullDetails.user = this.selectedUser;
    userFullDetails.profile = this.selectedUserProfile;

    this.usersService.UserProfileUpdate(userFullDetails).subscribe(
      () => {
        this.GetBrokerUsers();
        this.HideModal();
        this.showError = false;
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
      }
    );
  }

  fiaApplicationApplyClicked() {
    this.busy = true;
    this.fiaService.FiaApplcation(this.newFia).subscribe(
      () => {
        this.GetBrokerUsers();
        this.HideModal();
        this.showError = false;
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  mediaSaveClicked() {
    this.busy = true;

    this.DeleteUserMedia().then(
      () => {
        //Delete media first
        this.UploadUserMedia().then(
          () => {
            //Upload new docs
            this.GetBrokerUsers();
            this.HideModal();
          },
          (error) => {
            this.busy = false;
          }
        );
      },
      (error) => {
        this.busy = false;
      }
    );
  }

  public DeleteUserMedia() {
    return new Promise((resolve) => {
      if (!this.selectedUserDocumentsToDelete || this.selectedUserDocumentsToDelete.length == 0) {
        resolve(true);
      }

      this.selectedUserDocumentsToDelete.forEach((element) => {
        this.mediaService.DeleteMedia(element).subscribe(
          () => {},
          (error) => {
            this.showError = true;
            this.errorMsg = error.error.ErrorDetail;
            resolve(false);
          }
        );
      });
      resolve(true);
    });
  }

  public UploadUserMedia() {
    return new Promise((resolve) => {
      if (!this.selectedUserNewDocuments || this.selectedUserNewDocuments.length == 0) {
        resolve(true);
      }

      this.selectedUserNewDocuments.forEach((element) => {
        this.mediaService.UploadMedia(element).subscribe(
          () => {},
          (error) => {
            this.showError = true;
            this.errorMsg = error.error.ErrorDetail;
            resolve(false);
          }
        );
        resolve(true);
      });
    });
  }
  //===============CRUD Methods===============

  //===============File handling===============
  addFiles() {
    this.file.nativeElement.click();
  }

  onFileChange(fileInput: any) {
    this.selectedUserNewDocuments = [];
    var totalSize: number = 0;
    var maxSize: number = 5000000;
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          if (totalSize <= maxSize && files[key].size <= maxSize) {
            var file: MediaInfo = new MediaInfo();
            file.name = files[key].name;
            file.fileName = files[key].name;
            file.mimeType = files[key].type;
            file.tag = 'FiaApplication';
            file.data = event.target.result;
            file.data = file.data.replace('data:' + files[key].type + ';base64,', '');
            file.entityId = this.selectedUserProfile.userId;
            file.entityType = this.settingsService.userEntity.description; // Users
            totalSize += files[key].size;
            this.selectedUserNewDocuments.push(file);
          } else {
            console.log('Max upload size reached');
            this.showError = true;
            this.errorMsg = 'Max file upload size reached';
          }
        };

        reader.readAsDataURL(files[key]);
      }
    }
  }

  removeFile(fileName: string) {
    this.busy = true;
    this.selectedUserNewDocuments.forEach((value, index) => {
      if (value.fileName == fileName) {
        this.selectedUserNewDocuments.splice(index, 1);
      }
    });
    this.busy = false;
  }

  deleteFile(id: number) {
    this.busy = true;
    console.log(id);
    var userDocs = [];
    this.selectedUserDocuments.forEach((value, index) => {
      if (value.id != id) {
        userDocs.push(this.selectedUserDocuments[index]);
      }
    });
    this.selectedUserDocuments = userDocs;
    this.selectedUserDocumentsToDelete.push(id);
    this.busy = false;
  }

  //===============End File handling===============

  //===============Modal Controls===============
  ShowModal(user: UserFullDetails, Modal: string) {
    this.SelectUser(user);

    if (Modal == 'userInfoModal') {
      this.userInfoModal.show();
    } else if (Modal == 'userFiaPinsModal') {
      this.userFiaPinsModal.show();
    } else if (Modal == 'userDocumentsModal') {
      this.GetUserMedia();
      this.userDocumentsModal.show();
    } else if (Modal == 'userFiaApplicationModal') {
      this.newFia.fiaAmount = this.selectedUserProfile.fiaAmount;
      this.newFia.userId = this.selectedUserProfile.userId;
      this.userFiaApplicationModal.show();
    }
  }

  HideModal() {
    this.selectedUserDocuments = [];
    this.selectedUserDocumentsToDelete = [];
    this.selectedUserNewDocuments = [];

    this.userInfoModal.hide();
    this.userFiaPinsModal.hide();
    this.userDocumentsModal.hide();
    this.userFiaApplicationModal.hide();
  }

  confirmDelete(id: number) {}

  cancelDelete() {}
  //===============Modal Controls===============
}
